import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  /** 状态：存储令牌和用户信息，从 localStorage 初始化 */
  state: {
    token: localStorage.getItem('ebir_token') || '',
    userInfo: JSON.parse(localStorage.getItem('ebir_userInfo') || 'null')
  },
  mutations: {
    /**
     * 设置令牌并持久化到 localStorage
     * @param {Object} state - Vuex 状态
     * @param {string} token - JWT 令牌
     */
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('ebir_token', token)
    },
    /**
     * 设置用户信息并持久化到 localStorage
     * @param {Object} state - Vuex 状态
     * @param {Object} userInfo - 用户信息对象
     */
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('ebir_userInfo', JSON.stringify(userInfo))
    },
    /**
     * 清除令牌和用户信息（退出登录时调用）
     * @param {Object} state - Vuex 状态
     */
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('ebir_token')
      localStorage.removeItem('ebir_userInfo')
    }
  },
  actions: {
    /**
     * 登录动作：同时提交令牌和用户信息
     * @param {Function} commit - Vuex commit 方法
     * @param {Object} payload - 包含 token 和 userInfo 的对象
     */
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    /**
     * 退出登录动作：清除所有认证信息
     * @param {Function} commit - Vuex commit 方法
     */
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  },
  getters: {
    /** 是否已登录（令牌存在即为已登录） */
    isLoggedIn: state => !!state.token,
    /** 获取用户昵称，优先取 nickname，其次取 username */
    nickname: state => state.userInfo?.nickname || state.userInfo?.username || ''
  }
})
